import { useState } from "react";
import { useAppBridge } from "@shopify/app-bridge-react";
import { useForm } from "react-hook-form";

import { FormProvider, RHFCheckbox } from "../../../components/hook-form";
// hooks
import useLocales from "../../../hooks/useLocales";
import useShopContext from "../../../hooks/useShopContext";
import useOrdersContext from "../../../hooks/useOrdersContext";
import ConfirmDialogPolaris from "../../../components/ConfirmDialog";
import styled from "styled-components";
import { Button, ButtonGroup } from "@shopify/polaris";
import RHFSelect from "../../../components/hook-form/v2/RHFSelect";
// constants

const Text = styled.p`
  font-size: 13px;
  font-weight: 650;
  font-family: "Inter";
`;

const ButtonGroupBox = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
`;

const ExportCSVModalOrders = ({ open, onClose }) => {
  const [exporting, setExporting] = useState(false);

  const { translate } = useLocales();
  const shopify = useAppBridge();

  const { shop } = useShopContext();
  const { exportOrdersNotificationsCSV } = useOrdersContext();

  const methods = useForm({
    defaultValues: {
      interval: 7,
      preOrder: false,
    },
  });

  const { handleSubmit, reset } = methods;

  const onSubmit = async (fields) => {
    try {
      setExporting(true);

      const result = await exportOrdersNotificationsCSV(fields);

      if (result) {
        // shopify.toast.show(`${translate("page.bis-notifications.export-csv-successed")}  ${shop.email}`);
        shopify.toast.show(
          `${translate("tobetranslated.bis-notifications.export-csv-successed-short")}  ${shop.email}`
        );
      } else {
        shopify.toast.show(`${translate("tobetranslated.bis-notifications.export-csv-not-found")}`);
      }
    } catch {
      shopify.toast.show(`${translate("messages.error-occured")}`);
    } finally {
      setExporting(false);
    }
  };

  const handleClose = () => {
    onClose();
    reset();
  };

  const intervalOptions = [
    { value: "7", label: translate("page.bis-notifications.time-frame.week") },
    { value: "30", label: translate("page.bis-notifications.time-frame.month") },
    { value: "90", label: translate("page.bis-notifications.time-frame.90days") },
  ];

  return (
    <ConfirmDialogPolaris
      open={open}
      onClose={handleClose}
      title={<Text>{translate("page.bis-notifications.time-frame-title")}</Text>}
      content={
        <>
          <FormProvider methods={methods}>
            <RHFSelect
              name="interval"
              label={translate("page.bis-notifications.time-frame-label")}
              options={intervalOptions}
            />
            <div style={{ marginTop: "10px" }}></div>
            <RHFCheckbox label={translate("page.pre-order-notifications.only-po-products")} name="preOrder" />
          </FormProvider>
          <ButtonGroupBox>
            <ButtonGroup>
              <Button onClick={handleClose}>{translate("common.cancel")}</Button>
              <Button onClick={handleSubmit(onSubmit)} loading={exporting} variant="primary">
                {translate("common.export")}
              </Button>
            </ButtonGroup>
          </ButtonGroupBox>
        </>
      }
    />
  );
};

export default ExportCSVModalOrders;
